import React, { useState, useEffect } from 'react';
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import { getFirestore, collection, query, getDocs, where, Timestamp } from "@firebase/firestore";
import { app } from '../../firebase.js';
import { getAuth } from "firebase/auth";
import Table from 'react-bootstrap/Table';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function StudentSources() {
  const db = getFirestore(app);
  const auth = getAuth();
  const [sourceData, setSourceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const fetchStudents = async () => {
      setLoading(true);
      let q = collection(db, 'users');

      // Add date filtering if both dates are selected
      if (startDate && endDate) {
        const startTimestamp = Timestamp.fromDate(new Date(startDate));
        const endTimestamp = Timestamp.fromDate(new Date(endDate));
        q = query(q, where('appDate', '>=', startTimestamp), where('appDate', '<=', endTimestamp));
      }

      const querySnapshot = await getDocs(q);

      // Count sources
      const counts = {};
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const source = data.hear ? data.hear.toLowerCase() : 'unknown';
        counts[source] = (counts[source] || 0) + 1;
      });

      // Convert to chart-friendly format
      const formattedData = Object.keys(counts).map((key) => ({
        name: key,
        value: counts[key],
      }));

      const sortedData = formattedData.sort((a, b) => b.value - a.value);

      setSourceData(sortedData);
      setLoading(false);
    };

    fetchStudents();
  }, [db, startDate, endDate]);

  const COLORS = [
    '#0088FE', '#00C49F', '#FFBB28', '#FF8042',
    '#A28BFF', '#FF6384', '#36A2EB', '#4BC0C0',
  ];

  return (
    <div className='mainContainer'>
      <LeftBar/>
      <div className='theMainContainer'>
        <Dashnav/>
        <div className="clientsComp mt-4"> 
          <h4>Student Sources</h4>

          {/* Date Filter Inputs */}
          <div className="mb-3">
            <label>From: </label>
            <input type="date" className="form-control d-inline-block w-auto me-2"  value={startDate} onChange={e => setStartDate(e.target.value)} />
            <label className="ms-3">To: </label>
            <input type="date" className="form-control d-inline-block w-auto me-2"  value={endDate} onChange={e => setEndDate(e.target.value)} />
          </div>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <div style={{ width: '100%', height: 400 }}>
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={sourceData.slice(0, 8)}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={150}
                      label
                    >
                      {sourceData.slice(0, 8).map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>

              <Table striped bordered hover className="mt-4">
                <thead>
                  <tr>
                    <th>Source</th>
                    <th>Number of Students</th>
                  </tr>
                </thead>
                <tbody>
                  {sourceData.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.name}</td>
                      <td>{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </div>    
      </div>
    </div>
  );
}

export default StudentSources;